export default __webpack_public_path__ + "static/media/logo.b82d688c.png";